'use client'

import {useTranslations} from "next-intl";
import clsx from "clsx";

interface Props {
    buttonText: string
    className: string
}

export default function CookieLayerLink({buttonText, className}: Props) {
    const t = useTranslations("Defaults");
    return (
        <button type="button"
                className={clsx(className, "font-bold underline hover:text-brand-warm-grey")}
                aria-label={t("openCookieLayer")}
                onClick={() => window.hc_consent.push("show_modal")}>
            {buttonText}
        </button>
    )
}